package org.solyton.solawi.bid.module.user.`data`.address

import kotlin.String
import org.evoleq.axioms.definition.ReadOnly
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens

/**
 * Autogenerated ReadOnly Lens.
 * Read [Address.addressId]
 */
@ReadOnly
public val addressId: Lens<Address, String> by lazy {
      Lens(
        get = { whole -> whole.addressId },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [Address.recipientName]
 */
@ReadWrite
public val recipientName: Lens<Address, String> by lazy {
      Lens(
        get = { whole -> whole.recipientName },
        set = { part -> { whole -> whole.copy(recipientName = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Address.recipientName]
 */
@ReadWrite
public fun Address.recipientName(`set`: String.() -> String): Address = copy(recipientName =
    set(recipientName))

/**
 * Autogenerated Lens.
 * Read and manipulate [Address.organizationName]
 */
@ReadWrite
public val organizationName: Lens<Address, String?> by lazy {
      Lens(
        get = { whole -> whole.organizationName },
        set = { part -> { whole -> whole.copy(organizationName = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Address.organizationName]
 */
@ReadWrite
public fun Address.organizationName(`set`: String?.() -> String?): Address = copy(organizationName =
    set(organizationName))

/**
 * Autogenerated Lens.
 * Read and manipulate [Address.addressLine1]
 */
@ReadWrite
public val addressLine1: Lens<Address, String> by lazy {
      Lens(
        get = { whole -> whole.addressLine1 },
        set = { part -> { whole -> whole.copy(addressLine1 = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Address.addressLine1]
 */
@ReadWrite
public fun Address.addressLine1(`set`: String.() -> String): Address = copy(addressLine1 =
    set(addressLine1))

/**
 * Autogenerated Lens.
 * Read and manipulate [Address.addressLine2]
 */
@ReadWrite
public val addressLine2: Lens<Address, String> by lazy {
      Lens(
        get = { whole -> whole.addressLine2 },
        set = { part -> { whole -> whole.copy(addressLine2 = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Address.addressLine2]
 */
@ReadWrite
public fun Address.addressLine2(`set`: String.() -> String): Address = copy(addressLine2 =
    set(addressLine2))

/**
 * Autogenerated Lens.
 * Read and manipulate [Address.city]
 */
@ReadWrite
public val city: Lens<Address, String> by lazy {
      Lens(
        get = { whole -> whole.city },
        set = { part -> { whole -> whole.copy(city = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Address.city]
 */
@ReadWrite
public fun Address.city(`set`: String.() -> String): Address = copy(city = set(city))

/**
 * Autogenerated Lens.
 * Read and manipulate [Address.stateOrProvince]
 */
@ReadWrite
public val stateOrProvince: Lens<Address, String> by lazy {
      Lens(
        get = { whole -> whole.stateOrProvince },
        set = { part -> { whole -> whole.copy(stateOrProvince = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Address.stateOrProvince]
 */
@ReadWrite
public fun Address.stateOrProvince(`set`: String.() -> String): Address = copy(stateOrProvince =
    set(stateOrProvince))

/**
 * Autogenerated Lens.
 * Read and manipulate [Address.postalCode]
 */
@ReadWrite
public val postalCode: Lens<Address, String> by lazy {
      Lens(
        get = { whole -> whole.postalCode },
        set = { part -> { whole -> whole.copy(postalCode = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Address.postalCode]
 */
@ReadWrite
public fun Address.postalCode(`set`: String.() -> String): Address = copy(postalCode =
    set(postalCode))

/**
 * Autogenerated Lens.
 * Read and manipulate [Address.countryCode]
 */
@ReadWrite
public val countryCode: Lens<Address, String> by lazy {
      Lens(
        get = { whole -> whole.countryCode },
        set = { part -> { whole -> whole.copy(countryCode = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Address.countryCode]
 */
@ReadWrite
public fun Address.countryCode(`set`: String.() -> String): Address = copy(countryCode =
    set(countryCode))
